import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

import { BlockableUI } from 'primeng/api/public_api';

import { PainelComponent,PanelFooter,PanelHeader,PanelContent } from './painel.component';
import { DirectivesModule } from '../../directives/directives.module';
import { ButtonModule } from 'primeng/button';


@NgModule({
    declarations: [PainelComponent,PanelHeader,PanelFooter,PanelContent],
    exports: [PainelComponent,PanelHeader,PanelFooter,PanelContent],
    imports: [ CommonModule, BrowserModule, DirectivesModule, ButtonModule]
})
export class PainelModule  {

}